// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"HomeMainButtons_Wrapper__Oh2m8","NoCardCreditRequired":"HomeMainButtons_NoCardCreditRequired__FnTP_","TestsMainButton":"HomeMainButtons_TestsMainButton__dMy0c"};